import React from "react";

import { Badge } from "@/components/ui/Badge";

// A bare tag with no icon — "platform", "canary". It names what a row *is*,
// where `Chip` reports what state a row is in.
const TagChip = ({ tone, label, title }) => (
    <Badge
        variant="solid"
        colorIndex={tone}
        label={label}
        title={title}
        className="rounded-full shrink-0"
        badgeStyle="px-1.5 py-0 text-[10px] font-medium"
    />
);

export default TagChip;
